import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useGroupCompletionsPerUser(
  groupId: string,
  fromDate: string,
  toDate: string,
  enabled = true,
) {
  return useQuery({
    queryKey: ["groupAnalytics", groupId, "completionsPerUser", fromDate, toDate],
    queryFn: () =>
      api.getGroupCompletionsPerUser(groupId, {
        from_date: fromDate,
        to_date: toDate,
      }),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
